import * as React from 'react';
import styles from './PaymentMethod.module.scss'
import { useState } from "react";
import TextField from '@mui/material/TextField';
import Card from "../Card/Card";
import {
    Typography,
    Box,
    Grid,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    tableCellClasses,
} from "@mui/material";
// import Typography from '@mui/material/Typography';
import completeForm from '../../assets/completeForm.svg'
import creditCardIcon from '../../assets/credit-card-icon.svg'
import bankTransferIcon from '../../assets/bank-transfer-icon.svg'
import { useForm, Controller } from 'react-hook-form'
import SendRequest from "../../request/SendRequest";
import MenuItem from '@mui/material/MenuItem';
import Dialog from '@mui/material/Dialog';
import { CloseButton } from "react-bootstrap";
import SubscriberChangePaymentMethod from "../../components/SubscriberChangePaymentMethod/SubscriberChangePaymentMethod";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { styled, useTheme } from '@mui/material/styles';

const PaymentMethod = ({
    lastPaymentMethodData,
    availableBanksData,
    userInfoData,
    noEmailInProfile,
    editProfile,
    setEditProfile,
    editPaymentMethod,
    setEditPaymentMethod,
    setSnackBar,
}) => {
    const [loading, setLoading] = useState(false)

    const [targetPaymentMethod, setTargetPaymentMethod] = useState('creditCard');

    const [noticeDialogOpen, setNoticeDialogOpen] = useState(false)
    const handleNoticeDialogClose = () => {
        setNoticeDialogOpen(false)
        window.location.reload()
    }

    const [updateEmailDialogOpen, setUpdateEmailDialogOpen] = useState(false)
    const handleUpdateEmailDialogClose = () => {
        setUpdateEmailDialogOpen(false)
    }

    const checkPaymentMethodEditable = (paymentMethod = "creditCard") => {
        if (noEmailInProfile) {
            setUpdateEmailDialogOpen(true)
        } else {
            setTargetPaymentMethod(paymentMethod)
            setEditPaymentMethod(true)
        }
    }

    const theme = useTheme();

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        '&.MuiTableCell-root': {
            verticalAlign: 'top',
        },
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: '#FFF3F6',
            color: '#555555',
            fontWeight: 500,
            fontSize: 14,
            padding: '2px 8px',
            border: '1px solid #FFFFFF',
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14,
            color: '#555555',
            padding: '2px 8px',
            border: '1px solid #FFFFFF',
        },
    }));

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(even)': {
            backgroundColor: '#F0F0F0',
        },
    }));
    return (
        <>
            <Backdrop
                sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1301 })}
                open={loading}
                invisible
            >
                <CircularProgress style={{'color': '#495057'}} />
            </Backdrop>
            {
                !editPaymentMethod &&
                <div className={`subscriber-profile-info ${styles["subscriber-profile-info"]}`}>
                    <Typography variant="h2" gutterBottom width={'100%'} textAlign={"left"} color={"rgba(67, 71, 78, 1)"} fontSize={"14px"} fontWeight={500}>
                    繳費方式
                    </Typography>
                    <Card fullWidth={true}>
                        {
                            (lastPaymentMethodData.canUpdatePaymentMethod === true) &&
                            <Box width={"100%"} maxWidth={"356px"} display={"flex"} flexDirection={"column"} margin={"0 auto"} gap={"12px"}>
                                {
                                    (lastPaymentMethodData.paymentMethod === 'otherPaymentMethod') &&
                                    <>
                                        <Box width={"100%"} display={"flex"} flexDirection={"row"}>
                                            <Box width={"38px"} height={"38px"} borderRadius={"12px"} bgcolor={"#fff6f3"} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                                                <img src={completeForm} style={{ width: '24px', height: '24px' }} />
                                            </Box>
                                            <Box width={"100%"} padding={"10px 12px"} fontSize={"14px"} fontWeight={500} color={"#666666"} textAlign={"left"}>
                                                現時繳費方式 ： {lastPaymentMethodData.paymentMethodLabel}
                                            </Box>
                                        </Box>
                                        <Box width={"100%"} display={"flex"} justifyContent={"center"}>
                                            <Button
                                                type="button"
                                                variant="outlined"
                                                color="primary"
                                                size="medium"
                                                onClick={(e) => { e.preventDefault(); checkPaymentMethodEditable('creditCard'); }}
                                            >
                                                更換為信用卡/銀行戶口轉帳
                                            </Button>
                                        </Box>
                                    </>
                                }
                                {
                                    (lastPaymentMethodData.paymentMethod === 'creditCard') &&
                                    <>
                                        <Box width={"100%"} display={"flex"} flexDirection={"row"}>
                                            <Box width={"38px"} height={"38px"} borderRadius={"12px"} bgcolor={"#fff6f3"} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                                                <img src={creditCardIcon} style={{ width: '24px', height: '24px' }} />
                                            </Box>
                                            <Box width={"100%"} padding={"10px 12px"} fontSize={"14px"} fontWeight={500} color={"#666666"} textAlign={"left"}>
                                                現時繳費方式 ： {lastPaymentMethodData.paymentMethodLabel}
                                            </Box>
                                        </Box>
                                        <Box>
                                            <TextField
                                                inputProps={{ readOnly : true }}
                                                fullWidth
                                                readOnly
                                                variant="filled"
                                                label="信用卡號碼"
                                                value={lastPaymentMethodData.paymentCardNumber}
                                                slotprops={{
                                                    inputLabel: {
                                                        shrink: true,
                                                    },
                                                }}
                                            />
                                        </Box>
                                        <Box width={"100%"} display={"flex"} justifyContent={"center"}>
                                            <Button
                                                type="button"
                                                variant="outlined"
                                                color="primary"
                                                size="medium"
                                                onClick={(e) => { e.preventDefault(); checkPaymentMethodEditable('creditCard'); }}
                                            >
                                                編輯
                                            </Button>
                                        </Box>
                                        <hr style={{ color: "rgba(200, 200, 200, 1)" }} />
                                        <Box width={"100%"} display={"flex"} justifyContent={"center"}>
                                            <Button
                                                type="button"
                                                variant="outlined"
                                                color="primary"
                                                size="medium"
                                                onClick={(e) => { e.preventDefault(); checkPaymentMethodEditable('bankTransfer'); }}
                                            >
                                                更換為銀行戶口轉帳
                                            </Button>
                                        </Box>
                                    </>
                                }
                                {
                                    (lastPaymentMethodData.paymentMethod === 'bankTransfer') &&
                                    <>
                                        <Box width={"100%"} display={"flex"} flexDirection={"row"}>
                                            <Box width={"38px"} height={"38px"} borderRadius={"12px"} bgcolor={"#fff6f3"} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                                                <img src={bankTransferIcon} style={{ width: '24px', height: '24px' }} />
                                            </Box>
                                            <Box width={"100%"} padding={"10px 12px"} fontSize={"14px"} fontWeight={500} color={"#666666"} textAlign={"left"}>
                                                現時繳費方式 ： {lastPaymentMethodData.paymentMethodLabel}
                                            </Box>
                                        </Box>
                                        <Box>
                                            <TextField
                                                inputProps={{ readOnly : true }}
                                                fullWidth
                                                readOnly
                                                variant="filled"
                                                label="銀行戶口號碼"
                                                value={lastPaymentMethodData.paymentCardNumber}
                                                slotprops={{
                                                    inputLabel: {
                                                        shrink: true,
                                                    },
                                                }}
                                            />
                                        </Box>
                                        <Box width={"100%"} display={"flex"} justifyContent={"center"}>
                                            <Button
                                                type="button"
                                                variant="outlined"
                                                color="primary"
                                                size="medium"
                                                onClick={(e) => { e.preventDefault(); checkPaymentMethodEditable('bankTransfer'); }}
                                            >
                                                編輯
                                            </Button>
                                        </Box>
                                        <hr style={{ color: "rgba(200, 200, 200, 1)" }} />
                                        <Box width={"100%"} display={"flex"} justifyContent={"center"}>
                                            <Button
                                                type="button"
                                                variant="outlined"
                                                color="primary"
                                                size="medium"
                                                onClick={(e) => { e.preventDefault(); checkPaymentMethodEditable('creditCard'); }}
                                            >
                                                更換為信用卡戶口轉帳
                                            </Button>
                                        </Box>
                                    </>
                                }
                                {
                                    (lastPaymentMethodData.requestUpdatePaymentMethodStatus == 'processing' || lastPaymentMethodData.requestUpdatePaymentMethodStatus == 'failed') &&
                                    <TableContainer>
                                        <Table sx={{
                                            minWidth: 300,
                                            width: "max-content",
                                        }}
                                        size="small" aria-label="change payment method record table">
                                            <TableHead>
                                                <StyledTableRow>
                                                    <StyledTableCell>提交更改日期​</StyledTableCell>
                                                    <StyledTableCell>更改繳費方式​</StyledTableCell>
                                                    <StyledTableCell>現時狀態​</StyledTableCell>
                                                </StyledTableRow>
                                            </TableHead>
                                            <TableBody>
                                                <StyledTableRow>
                                                    <StyledTableCell>{`${lastPaymentMethodData.requestUpdatePaymentMethodDate}`}</StyledTableCell>
                                                    <StyledTableCell>{`${lastPaymentMethodData.requestUpdatePaymentMethodDetails == 'bankTransfer' ? '銀行自動轉帳' : '信用卡自動轉帳'}`}</StyledTableCell>
                                                    <StyledTableCell>{`${lastPaymentMethodData.requestUpdatePaymentMethodStatus == 'processing' ? '等待銀行處理' : '未被銀行接納，請向銀行查詢'}`}</StyledTableCell>
                                                </StyledTableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                }
                                <Box textAlign={"left"} paddingTop={"12px"} fontSize={"13px"} color={"rgba(67, 71, 78, 1)"}>
                                    更改繳費方式或繳費資料將套用至您名下所有用戶帳號。如果您需要用不同方式為不同用戶繳費，請您按頁面右下角“意見查詢”聯絡客戶服務部。
                                </Box>
                            </Box>
                        }
                        {
                            (lastPaymentMethodData.canUpdatePaymentMethod === false) &&
                            <Box width={"100%"} maxWidth={"356px"} display={"flex"} flexDirection={"column"} margin={"0 auto"} gap={"12px"}>
                                <Box textAlign={"left"} paddingTop={"12px"} fontSize={"13px"} color={"rgba(67, 71, 78, 1)"}>
                                    現時您名下的不同用戶正使用不同的繳費方式，如要更改繳費方式，請您按頁面右下角“提供意見/客服查詢”聯絡客戶服務部。
                                </Box>
                            </Box>
                        }
                    </Card>
                    <Dialog
                        className={`${styles["file-input"]}`}
                        open={noticeDialogOpen}
                        onClose={handleNoticeDialogClose}
                        disablePortal
                        maxWidth="md"
                        PaperProps={{style:{margin:0,borderRadius:"10px"}}}
                        sx={{ borderRadius: "40px", width: "100%" }}
                    >
                        <div className={styles["confirm-dialog"]}>
                            <div className={styles["dialog-close-div"]}>
                                <CloseButton style={{ marginLeft: "auto" }} onClick={handleNoticeDialogClose}></CloseButton>
                            </div>

                            <div className={styles["dialog-content"]}>
                                <div className={styles["info-row"]}>
                                    協會將轉遞您的“授權轉賬同意書”至銀行申請轉帳辦理，需待銀行審批。若成功通過審批，將會於(信用卡:15至20日 / 銀行戶口: 26日)從您的戶口轉帳每月費用，請您預留足夠金額及留意轉帳情況。
                                </div>
                            </div>
                            <div className={styles["dialog-actions"]}>
                                <Button
                                    type="button"
                                    variant="outlined"
                                    color="primary"
                                    size="medium"
                                    onClick={handleNoticeDialogClose}
                                >
                                    確定
                                </Button>
                            </div>
                        </div>
                    </Dialog>
                    <Dialog
                        className={`${styles["file-input"]}`}
                        open={updateEmailDialogOpen}
                        onClose={handleUpdateEmailDialogClose}
                        disablePortal
                        maxWidth="md"
                        PaperProps={{style:{margin:0,borderRadius:"10px"}}}
                        sx={{ borderRadius: "40px", width: "100%" }}
                    >
                        <div className={styles["confirm-dialog"]}>
                            <div className={styles["dialog-close-div"]}>
                                <CloseButton style={{ marginLeft: "auto" }} onClick={handleUpdateEmailDialogClose}></CloseButton>
                            </div>

                            <div className={styles["dialog-content"]}>
                                <div className={styles["info-row"]}>
                                    請先登記電郵地址以編輯其他資訊。
                                </div>
                            </div>
                            <div className={styles["dialog-actions"]}>
                                <Button
                                    type="button"
                                    variant="outlined"
                                    color="primary"
                                    size="medium"
                                    onClick={handleUpdateEmailDialogClose}
                                >
                                    取消
                                </Button>
                                <Button
                                    type="button"
                                    variant="outlined"
                                    color="primary"
                                    size="medium"
                                    onClick={() => { setEditProfile(true); handleUpdateEmailDialogClose(); }}
                                >
                                   編輯
                                </Button>
                            </div>
                        </div>
                    </Dialog>
                </div>
            }
            {
                editPaymentMethod &&
                <SubscriberChangePaymentMethod
                    paymentMethodData={lastPaymentMethodData}
                    targetPaymentMethod={targetPaymentMethod}
                    availableBanks={availableBanksData}
                    userInfoData={userInfoData}
                    edit={editPaymentMethod}
                    setEdit={setEditPaymentMethod}
                    setNoticeDialogOpen={setNoticeDialogOpen}
                    loading={loading}
                    setLoading={setLoading}
                    setSnackBar={setSnackBar}
                />
            }
        </>
    )
}

export default PaymentMethod